<template>
  <div
    class="moow-master-container play-background"
    v-loading.fullscreen="loading"
    element-loading-text="Saving Data ..."
    element-loading-spinner="el-icon-loading"
  >
    <nav-basic :progress="30" title=""></nav-basic>
    <div class="container">
      <b-row class="step-header">
        <p class="moow-header">Let's go over the rooms</p>
      </b-row>
      <b-row>
        <b-col md="6" cols="12">
          <md-card class="island-card pr-3">
            <md-card-content>
              <b-row>
                <b-col class="text-right pr-0">
                  <p class="input-header">Entry Floor/ Number of Floors</p>
                  <b-row style="border:none" class="text-center" align-v="center">
                    <b-col>
                      <b-form-input
                        type="number"
                        class="text-center moow-input"
                        v-model="techDet.entryFloor"
                        required
                      />
                    </b-col>
                    <b-col md="1">/</b-col>
                    <b-col>
                      <b-form-input
                        type="number"
                        :min="1"
                        class="text-center moow-input"
                        v-model="techDet.buildingNrOfFloor"
                        required
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <hr class="hr-form-el-separator" />

              <b-row>
                <b-col>
                  <p class="input-header">Number of Rooms</p>
                  <el-input-number
                    v-model="techDet.nrOfRooms"
                    id="inputHorizontal"
                    :min="1"
                    :max="60"
                    style="width:50%"
                    required
                  ></el-input-number>
                </b-col>
              </b-row>
              <hr class="hr-form-el-separator" />

              <b-row>
                <b-col>
                  <p class="input-header">Guests</p>
                  <el-input-number
                    v-model="techDet.nrOfGuests"
                    id="inputHorizontal"
                    :min="1"
                    :max="10"
                    style="width:50%"
                    required
                  ></el-input-number>
                  <p class="input-hint">Nr of people the place can accommodate</p>
                </b-col>
              </b-row>
              <hr class="hr-form-el-separator" />

              <b-row>
                <b-col>
                  <p class="input-header">Bedrooms</p>
                  <el-input-number
                    v-model="techDet.nrOfBedrooms"
                    id="inputHorizontal"
                    :min="0"
                    :max="10"
                    style="width:50%"
                    required
                  ></el-input-number>
                </b-col>
              </b-row>
              <hr class="hr-form-el-separator" />

              <b-row>
                <b-col>
                  <p class="input-header">Bathrooms</p>
                  <el-input-number
                    v-model="techDet.nrOfBathrooms"
                    id="inputHorizontal"
                    :min="0"
                    :max="10"
                    style="width:50%"
                    required
                  ></el-input-number>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <p class="input-header mb-2">Separate WC & Shower?</p>
                  <b-form-radio-group
                    :options="[{text:'Yes',value:'true'},{text:'No',value:'false'}]"
                    v-model="wcAndBathSeparated"
                  ></b-form-radio-group>
                </b-col>
              </b-row>
              <hr class="hr-form-el-separator" />


              <p class="input-header mb-2 mt-4">Balcony?</p>
              <b-row>
                <b-col>
                  <toggle-button
                    v-model="balconies"
                    :height="35"
                    :width="70"
                    color="#1f8efa"
                  />
                </b-col>
                <b-col  v-if="balconies">
                  <p class="input-header mb-2"> </p>
                  <b-form-input
                    v-validate="'decimal'"
                    :min="0"
                    placeholder="m²"
                    style="width:50%"
                    class="moow-input"
                    v-model.number="areaM2"
                  ></b-form-input>
                  <br>
                  <b-form-radio-group
                    id="radios1"
                    v-if="balconies"
                    :options="[{text:'balcony',value:'true'},{text:'terrace',value:'false'}]"
                    v-model="balconyCategoryIsBalcony"
                  ></b-form-radio-group>
                </b-col>
              </b-row>


              <hr class="hr-form-el-separator" />

              <p class="input-header mb-2">Storage?</p>
              <b-row>
                <b-col>
                    <toggle-button
                      v-model="storage"
                      :height="35"
                      :width="70"
                      color="#1f8efa"
                    />
                </b-col>
                <b-col v-if="storage">

                  <b-form-checkbox-group
                    id="radios2"
                    v-model="techDet.storage"
                    :options="storageList"
                  ></b-form-checkbox-group>
                </b-col>
              </b-row>
            </md-card-content>
          </md-card>

           <b-row class="step-navigator-buttons">
              <b-col style="text-align:left;padding:0">
                <md-button @click="prev()" class="md-primary">
                  <md-icon>arrow_back</md-icon>Back
                </md-button>
              </b-col>
              <b-col style="text-align:right;padding:0">
                <md-button @click="next" class="md-primary play-cta-button makeup">Next</md-button>
              </b-col>
            </b-row>


        </b-col>
        <b-col md="5" offset-md="1">
          <md-card class="island-card">
            <md-card-header>
              <div class="automated-fields-icon"></div>
            </md-card-header>

            <md-card-content>
              <p
                class="moow-info-txt"
              >If there is data available, we will autofill some of the fields ourselves.</p>
              <p class="moow-info-txt">Double check to make sure the data is correct.</p>
            </md-card-content>
          </md-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// import { balconyTypeList, storageTypeList } from "../lists.js";
const lists = require("@/lists.js");

import { updateListingParts } from "../listingFunctions.js";
let techDet1;
export default {
  name: "basic3",
  data() {
    return {
      balconies: false,
      balconyCategoryIsBalcony: true,
      loading: false,
      nrOfBalconies: 0,
      storage: false,
      areaM2: undefined,
      balconyState: false,
      balcony: lists.balconyTypeList,
      storageList: lists.storageTypeList,
      storageState: true,
      balconyTypeState: false,
      wcAndBathSeparated: false
    };
  },
  created() {
    this.wcAndBathSeparated = this.$store.getters.techDet.wcAndBathSeparated;
  },
  watch: {
    storage() {
      if (this.storage == false) {
        // this.techDet.storage = []
        return (this.storageState = true);
      } else return (this.storageState = false);
    }
  },
  computed: {
    techDet() {
      return this.$store.getters.techDet;
    },
    adsOIdEhr() {
      if (sessionStorage.getItem("buildingServiceData"))
        return sessionStorage.getItem("buildingServiceData").adsOId;
    }
  },
  created() {
    if (this.$store.getters.basic3Visited) {
      this.populateFieldsFromStore();
    } else {
      this.populateFieldsFromEhrData(
        JSON.parse(sessionStorage.getItem("buildingServiceData"))
      );
    }
  },
  methods: {
    populateFieldsFromEhrData(bData) {
      if (bData && bData.techDet) {
        bData.techDet.nrOfGrndFlrs
          ? (this.techDet.buildingNrOfFloor = bData.techDet.nrOfGrndFlrs)
          : void 0;
      }
      if (bData && bData.parts[0]) {
        bData.parts[0].entryFloor
          ? (this.techDet.entryFloor = bData.parts[0].entryFloor)
          : void 0;
        this.techDet.nrOfRooms = bData.parts[0].nrOfRooms;
        let blcns = bData.parts[0].balconies;
        if (blcns && blcns.length > 0) {
          this.balconies = true;
          this.techDet.nrOfBalconies = blcns.length;
          this.areaM2 = blcns[0].areaM2;
        }
      } else {
        this.populateFieldsFromStore();
      }
    },
    populateFieldsFromStore() {
      if (
        this.$store.getters.techDet.balcony == undefined ||
        this.$store.getters.techDet.balcony.length == 0
      )
        this.balconies = false;
      else {
        this.chk = true;
        this.areaM2 = this.$store.getters.techDet.balcony[0].areaM2;
        this.balconies = true;
      }

      if (
        this.$store.getters.techDet.storage == undefined ||
        this.$store.getters.techDet.storage.length == 0
      )
        this.storage = false;
      else this.storage = true;
    },
    leavePage(from, to) {
      this.$store.dispatch("visitPage", from);
      this.$router.push({
        name: to
      });
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    setInputValuesToModel() {
      let myBalcony;
      if (!this.balconies || this.balconies == false) {
        this.techDet.balcony.splice(0);
        this.techDet.nrOfBalconies = 0;
        myBalcony = [];
      } else {
        this.techDet.nrOfBalconies = 1;
        let balcType = "terrace";
        if (this.balconyCategoryIsBalcony) balcType = "balcony";
        myBalcony = [
          {
            category: balcType,
            areaM2: this.areaM2
          }
        ];
      }
      this.techDet.balcony = myBalcony;
      if (this.storage == false) {
        this.techDet.storage.splice(0);
      }
      this.techDet.wcAndBathSeparated = this.wcAndBathSeparated;
    },
    save() {
      this.setInputValuesToModel();
      this.$store.commit("UPDATE_TECHDET", this.techDet);
      updateListingParts(this.createUpdateParts()).catch(err => {});
    },
    createUpdateParts() {
      return {
        techDet: this.techDet
      };
    },
    saveAndExit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          this.leavePage("BASIC3", "dashboard");
        } else {
          this.notifyError("Notification", "Something is missing");
        }
      });
    },
    next() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          this.leavePage("BASIC3", "basic4");
        } else {
          this.notifyError("Notification", "Something is missing");
        }
      });
    },
    prev() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.setInputValuesToModel();
          this.$store.commit("UPDATE_TECHDET", this.techDet);
          this.leavePage("BASIC3", "basic2");
        } else {
          this.notifyError("Notification", "Something is missing");
        }
      });
    }
  },
  props: {
    data: {
      type: Object,
      required: false
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../assets/styles/add-steps.css";
@import "../assets/styles/global.css";

#desc {
  background-color: rgb(240, 229, 229);
}

.checkBtn {
  opacity: 0;
  outline: none;
  position: absolute;
  margin: 0;
  left: -999px;
}

.button {
  margin: 10px;
  width: 150px;
  height: 40px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: #1f8efa;
  border-radius: 4px;
  border: solid 1px #1f8efa;
  background-color: #ffffff;
}

p {
  color: #757575;
  text-align: left;
  font-size: 14px;
}

.form-group {
  margin-bottom: 0px;
}

label {
  float: left;
}

/* .el-switch_button{
  transform: translate3d(60px, 0px, 0px);
} */
</style>



// WEBPACK FOOTER //
// src/components/basic3.vue